export default __webpack_public_path__ + "static/media/Foto32.eceb35a8.png";